webpackJsonp([1],Array(154).concat([
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Dashboard_Main__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Dashboard_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Dashboard_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Dashboard_Data__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Dashboard_Data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Dashboard_Data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Dashboard_Contact__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Dashboard_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Dashboard_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Dashboard_Visit__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Dashboard_Visit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Dashboard_Visit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Resetpass__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Resetpass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Resetpass__);



// Pages








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  history: true,
  linkActiveClass: 'uk-active',
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login___default.a
  }, {
    path: '/login/:id?/:hash([a-zA-Z0-9]+)?',
    name: 'LoginHash',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login___default.a
  }, {
    path: '/resetpass/:hash([a-zA-Z0-9]+)',
    name: 'Resetpass',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Resetpass___default.a
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    redirect: '/dashboard/main',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard___default.a,
    children: [{ path: 'main', name: 'main', component: __WEBPACK_IMPORTED_MODULE_4__pages_Dashboard_Main___default.a, meta: { name: 'Moje wizyty' } }, { path: 'data', name: 'data', component: __WEBPACK_IMPORTED_MODULE_5__pages_Dashboard_Data___default.a, meta: { name: 'Moje dane' } }, { path: 'contact', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_6__pages_Dashboard_Contact___default.a, meta: { name: 'Kontakt z kliniką' } }, { path: 'visit/:visitId,:status,:ankieta,:doctor,:data,:position,:reason,:adres1,:adres2,:information,:type,:cena', name: 'visit', component: __WEBPACK_IMPORTED_MODULE_7__pages_Dashboard_Visit___default.a, meta: { name: 'Widok wizyty' } }, { path: '*', name: 'page-not-found', redirect: 'main' }]
  }, {
    path: '*',
    redirect: '/dashboard/main'
  }]
}));

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
  __webpack_require__(207)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uikit_dist_js_uikit_icons__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uikit_dist_js_uikit_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uikit_dist_js_uikit_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_lodash__);











__WEBPACK_IMPORTED_MODULE_5_uikit___default.a.use(__WEBPACK_IMPORTED_MODULE_6_uikit_dist_js_uikit_icons___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value), 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value), 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDatefrom', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value), 'YYYY-MM-DD HH:mm:ss').lang('pl').fromNow();
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('truncate', function (string, value) {
  if (string.length > value) {
    return string.substring(0, value) + '...';
  }
  return string;
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login_app_footer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login_app_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login_app_footer__);
//
//
//
//
//
//
//


// import config from './portal-config.json'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    this.$http.get(location.protocol + '//' + location.host + '/portal-config.json').then(function (config) {
      _this.config = config.data[0].client;
    }, function (err) {
      console.log(err);
    });
  },

  components: {
    appFooter: __WEBPACK_IMPORTED_MODULE_0__pages_Login_app_footer___default.a
  },
  data: function data() {
    return {
      config: {
        logo_url: '',
        footer_text: '',
        clinic_info: {}
      }
    };
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_navbar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_leftmenu__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_leftmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_leftmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_footer__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dashboard_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dashboard_notifications__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dashboard_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Dashboard_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_l_carousel__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_l_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_l_carousel__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var getDomain = location.protocol + '//' + location.host;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_2__Dashboard_navbar___default.a,
    leftmenu: __WEBPACK_IMPORTED_MODULE_3__Dashboard_leftmenu___default.a,
    dashboardFooter: __WEBPACK_IMPORTED_MODULE_4__Dashboard_footer___default.a,
    notifications: __WEBPACK_IMPORTED_MODULE_5__Dashboard_notifications___default.a,
    'carousel': __WEBPACK_IMPORTED_MODULE_8_vue_l_carousel__["Carousel"],
    'carousel-item': __WEBPACK_IMPORTED_MODULE_8_vue_l_carousel__["CarouselItem"]
  },
  beforeMount: function beforeMount() {
    var _this = this;

    // Slider

    this.$http.post(getDomain + '/slider.php?number=1').then(function (response) {
      var images = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).map(function (x) {
        return { url: getDomain + '/slider1/' + x };
      });
      _this.list = images;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var vm = this;
    if (this.$cookie.get('aut')) {
      var refreshTokenMetod = { 'input': { 'status': '', 'data': { 'TOKEN': this.$cookie.get('aut'), 'reservation_id': null } } };
      this.$http.post(getDomain + '/api.php?url=refreshToken', refreshTokenMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        _this2.$cookie.set('aut', _this2.$cookie.get('aut'), { expires: '20m' });
      }).catch(function (errors) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        vm.logout();
      });
    } else {
      this.$router.push({ path: '/' });
    }
    vm.setSessionTimer();
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.page-wrapper').click(vm.refreshSession);
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#logout_btn').click(vm.logoutBtn);
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#logout_btn_small').click(vm.logoutBtn);
    // if (this.$cookie.get('aut')) {
    //   if (this.$cookie.get('cdata')) {
    //     this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
    //     this.LastName = $.parseJSON(this.$cookie.get('cdata')).lastname
    //     this.email = $.parseJSON(this.$cookie.get('cdata')).email
    //   }
    // }
  },

  methods: {
    setSessionTimer: function setSessionTimer() {
      var vm = this;
      vm.sessionInterval = setInterval(function (timeout) {
        if (vm.sessionTime === 1) {
          __WEBPACK_IMPORTED_MODULE_6_uikit___default.a.modal.alert('Użytkownik został wylogowany, ponieważ przez 20 minut nie została dokonana żadna czynność').then(function (closed) {
            vm.logout();
          });
        }
        vm.sessionTime--;
      }, 100 * 600);
    },
    logout: function logout() {
      var vm = this;
      vm.$cookie.delete('aut');
      localStorage.removeItem('unison_id');
      vm.$router.push({ path: '/' });
      window.clearInterval(vm.sessionInterval);
    },
    logoutBtn: function logoutBtn() {
      this.logout();
    },
    refreshSession: function refreshSession() {
      var _this3 = this;

      this.sessionTime = 20;
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var refreshTokenMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'reservation_id': null } } };
        this.$http.post(getDomain + '/api.php?url=refreshToken', refreshTokenMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          _this3.$cookie.set('aut', token, { expires: '20m' });
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        });
      }
    }
  },
  computed: {
    sessionValidToText: function sessionValidToText() {
      var time = this.sessionTime;
      var text;

      switch (time) {
        case 4:
        case 3:
        case 2:
          text = 'minuty';
          break;
        case 1:
          text = 'minutę';
          break;
        default:
          text = 'minut';

      }
      return time + ' ' + text;
    },
    config: function config() {
      return this.$parent.config;
    },
    firstName: function firstName() {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.parseJSON(this.$cookie.get('cdata')).name;
        }
      }
    },
    LastName: function LastName() {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.parseJSON(this.$cookie.get('cdata')).lastname;
        }
      }
    },
    email: function email() {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.parseJSON(this.$cookie.get('cdata')).email;
        }
      }
    }
    // if (this.$cookie.get('aut')) {
    //   if (this.$cookie.get('cdata')) {
    //     this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
    //     this.LastName = $.parseJSON(this.$cookie.get('cdata')).lastname
    //     this.email = $.parseJSON(this.$cookie.get('cdata')).email
    //   }
    // }

  },
  data: function data() {
    return {
      sessionTime: 20,
      // firstName: '',
      // LastName: '',
      // email: '',
      slider1: [{
        url: getDomain + '/slider1/slider_1_foto_1.jpg'
      }],
      auto: 3000,
      // list: this.slider1
      list: []
    };
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_l_carousel__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_l_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_l_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uikit__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDomain = location.protocol + '//' + location.host;
/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    var _this = this;

    // Slider

    this.$http.post(getDomain + '/slider.php?number=2').then(function (response) {
      var images = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).map(function (x) {
        return { url: getDomain + '/slider2/' + x };
      });
      _this.list = images;
    });
  },
  data: function data() {
    return {
      'firstName': '',
      'LastName': '',
      'email': '',
      auto: 5000,
      dots: true,
      list: [],
      files: [],
      messageTxt: '',
      contactMail: '',
      contactFromMail: ''
    };
  },

  computed: {
    config: function config() {
      return this.$parent.config;
    }
  },
  components: {
    'carousel': __WEBPACK_IMPORTED_MODULE_2_vue_l_carousel__["Carousel"],
    'carousel-item': __WEBPACK_IMPORTED_MODULE_2_vue_l_carousel__["CarouselItem"]
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#sliderMain').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#backbtn').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notifications').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.session-info-wrap').css('width', '100%');
    if (this.$cookie.get('cdata')) {
      this.firstName = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.parseJSON(this.$cookie.get('cdata')).name;
      this.LastName = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.parseJSON(this.$cookie.get('cdata')).lastname;
      this.email = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.parseJSON(this.$cookie.get('cdata')).email;
    }
    this.$http.get(getDomain + '/config.php').then(function (response) {
      var resp = response.data;
      _this2.contactMail = resp.emailZzalacznikiemAdres;
      _this2.contactFromMail = resp.emailZzalacznikiemFrom;
    }).catch(function (errors) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
    });
  },
  methods: {
    submitForm: function submitForm() {
      var _this3 = this;

      var formData = new FormData();
      formData.append('recipient', this.contactMail);
      formData.append('from', this.contactFromMail);
      formData.append('text', this.messageTxt);
      formData.append('unison_id', localStorage.getItem('unison_id'));
      // formData.append('sender', this.firstName + ' ' + this.LastName)
      formData.append('sender', 'Portal pacjenta');
      formData.append('email', this.email);
      // Jeśli dodany plik to wysyłamy na mail jeśli nie to wiadomość do Unison
      if (this.files.length === 0) {
        var token = this.$cookie.get('aut');
        var id = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.parseJSON(this.$cookie.get('cdata')).id;
        var newContact = { 'input': { 'messagetxt': this.messageTxt, 'data': { 'TOKEN': token, 'id': id } } };
        this.$http.post('/api.php?url=addNewContact', newContact, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          if (response.status === 200 && response.body.d.status === 'OK') {
            __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.modal.alert('Wiadomość została wysłana. Dziękujemy.');
            _this3.files.splice(0, _this3.files.length);
            _this3.messageTxt = '';
          } else {
            __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.modal.alert('Coś poszło nie tak... Spróbuj później');
          }
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.modal.alert('Coś poszło nie tak... Spróbuj później');
          console.error(errors);
        });
      } else {
        for (var i = 0; i < this.files.length; i++) {
          var file = this.files[i];
          formData.append('files[' + i + ']', file);
        }
        this.$http.post(getDomain + '/message.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.modal.alert('Wiadomość została wysłana. Dziękujemy.');
          _this3.files.splice(0, _this3.files.length);
          _this3.messageTxt = '';
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.modal.alert('Coś poszło nie tak... Spróbuj jeszcze raz');
        });
      }
    },
    handleFileUpload: function handleFileUpload() {
      var uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },
    removeFile: function removeFile(key) {
      this.files.splice(key, 1);
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      newEmail: '',
      id: '',
      credentials: {
        passNew_2: '',
        passNew: ''
      },
      Pacjent: {
        'IDPacjent': null,
        'IDPortal': null,
        'Nazwisko': null,
        'Imie': null,
        'Imie2': null,
        'PESEL': null,
        'DataUr': null,
        'MiejsceUr': null,
        'KodPocztowy': null,
        'Poczta': null,
        'Miejscowosc': null,
        'UlicaAlejaPlac': null,
        'Ulica': null,
        'NrDomu': null,
        'NrMieszkania': null,
        'Kraj': null,
        'KodPocztowy2': null,
        'Poczta2': null,
        'Miejscowosc2': null,
        'UlicaAlejaPlac2': null,
        'Ulica2': null,
        'NrDomu2': null,
        'NrMieszkania2': null,
        'Kraj2': null,
        'Tel': null,
        'TelKom': null,
        'Email': null
      },
      NFZElements: [{
        'IDPacjentNFZ': null,
        'IDPacjent': null,
        'IdNFZ': null,
        'Pole': null,
        'Wartosc': null,
        'Sciezka': null,
        'Opis': null
      }],
      error_box_empty: false,
      error_box_characters: false,
      error_box_mismatch: false
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#sliderMain').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#backbtn').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notifications').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.session-info-wrap').css('width', '100%');
    if (this.$cookie.get('aut')) {
      if (this.$cookie.get('cdata')) {
        this.firstName = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(this.$cookie.get('cdata')).name;
        this.lastName = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(this.$cookie.get('cdata')).lastname;
        this.email = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(this.$cookie.get('cdata')).email;
        this.id = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(this.$cookie.get('cdata')).id;
      }
    }
    this.credentials.passNew_2 = '';
    this.credentials.passNew = '';
    this.newEmail = this.email;

    var vm = this;
    var token = this.$cookie.get('aut');
    var data = { 'input': { 'data': { 'Token': token } } };
    vm.$http.post('/api.php?url=PacjentData', data, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
      var odp = response.data;
      vm.Pacjent = odp.d.Pacjent;
      vm.NFZElements = odp.d.NFZElements;
    }).catch(function (err) {
      if (err.status === 400) {
        __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Nieprawidłowe dane.');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
      }
    });
  },
  methods: {
    setEmail: function setEmail() {
      var _this = this;

      var vm = this;
      var regex = /^.+@.+$/;
      if (vm.newEmail === '' || !regex.test(vm.newEmail)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#email-patient-reminder-modal #error_empty_email').show();
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#email-patient-reminder-modal #error_empty_email').hide();
        var token = this.$cookie.get('aut');
        var data = { 'request': { 'Id': vm.id, 'Token': token, 'Email': vm.newEmail } };
        vm.$http.post('/api.php?url=SetEmail', data, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var cdata = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(_this.$cookie.get('cdata'));
          cdata.email = vm.newEmail;
          vm.email = vm.newEmail;
          _this.$cookie.set('cdata', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cdata), { expires: '1D' });
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dziękujemy.');
        }).catch(function (err) {
          if (err.status === 400) {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Nieprawidłowe dane.');
          } else {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
          }
        });
      }
    },
    setPass: function setPass() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_empty').hide();
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_characters').hide();
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_mismatch').hide();

      if (this.credentials.passNew && this.credentials.passNew_2) {
        var token = this.$cookie.get('aut');
        var setPassRequest = { 'request': { 'Id': this.id, 'NewPass': this.credentials.passNew_2, 'Token': token } };
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_mismatch').show();
        } else if (reg.test(this.credentials.passNew)) {
          // new pass validate ok
          this.$http.post('/api.php?url=SetPass', setPassRequest, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
            // var odp = response.data
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Hasło zostało poprawnie zmienione.');
            _this2.credentials.passNew_2 = '';
            _this2.credentials.passNew = '';
          }).catch(function (errors) {
            _this2.credentials.passNew_2 = '';
            _this2.credentials.passNew = '';
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem przy zmianie hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_characters').show();
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pass-change-modal #error_box_empty').show();
      }
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uikit__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main',
  orderKey: '',
  orderDir: 'asc',
  data: function data() {
    return {
      visits: [{
        'title': '',
        'link': '',
        'data': '',
        'reason': '',
        'doctor': '',
        'specjalizacja': '',
        'status': '',
        'type': '',
        'position': '',
        'idrejestracja': '',
        'ankieta': ''
      }]
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('refreshMain', function () {
      _this.getData();
    });
    this.getData();
  },
  methods: {
    sortBy: function sortBy(sortKey) {
      if (this.orderKey === sortKey) {
        this.orderDir = this.orderDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.orderDir = 'asc';
      }
      this.orderKey = sortKey;
      var visitsArr = this.visits;
      var sortedVisits = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(visitsArr, sortKey, this.orderDir);
      this.visits = sortedVisits;
    },
    getData: function getData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#sliderMain').css('display', 'block');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#backbtn').css('display', 'none');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#notifications').css('display', 'block');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#visitLoader').css('display', 'inline-block');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.session-info-wrap').css('width', '50%');
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var getVisitsMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token } }
          // var getVisitsMetod = {'input': {'status': '', 'data': {'TOKEN': 123}}}
          // TODO: Zaciągać API URL z XML
        };this.$http.post('/api.php?url=getVisits', getVisitsMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var resp = response.data;
          var visits = resp.d.data;
          /* check if api OK but data is empty
          if (JSON.stringify(visits) && JSON.stringify(visits) === '[]') {
            UIkit.modal.alert('Brak wizyt')
          }
          */
          _this2.visits = visits;
          _this2.orderDir = 'desc';
          _this2.orderKey = 'data';
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#visitLoader').css('display', 'none');
        }).catch(function (errors) {
          // JSON.stringify(errors)
          __WEBPACK_IMPORTED_MODULE_2_uikit___default.a.modal.alert('Coś poszło nie tak... Kod: ' + errors.status);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#visitLoader').css('display', 'none');
        });
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'visit',
  data: function data() {
    return {
      'platnoscOnline': '',
      'platnoscOnlineLink': '',
      'ankietaPar': '',
      'ankietaTxt': 'ANKIETA NIEDOSTĘPNA',
      'reason': '',
      'doctor': '',
      'data': '',
      'adres1': '',
      'adres2': '',
      'information': '',
      'type': '',
      'cena': '',
      'position': '',
      'status': '',
      'isBeforeVisit': '',
      documentsLoading: true,
      documents: [{
        'nazwa': '',
        'IDKorSzablon': '',
        'IDportal': '',
        'IDDokumenty': ''
      }]
    };
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#sliderMain').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#backbtn').css('display', 'block');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notifications').css('display', 'none');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.session-info-wrap').css('width', '100%');
    this.documentsLoading = true;
    if (this.$cookie.get('aut')) {
      var token = this.$cookie.get('aut');
      var visitId = this.$route.params.visitId;
      var getDocumentsMetod = { 'input': { 'status': '', 'TOKEN': token, 'id': visitId } };
      this.$http.post('/api.php?url=getDocuments', getDocumentsMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        var resp = response.data;
        var documents = resp.d.data;
        _this.documents = documents;
        _this.documentsLoading = false;
      }).catch(function (errors) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        _this.documents = null;
        _this.documentsLoading = false;
      });
    }
    this.ankietaPar = this.$route.params.ankieta;
    this.reason = this.$route.params.reason;
    this.status = this.$route.params.status;
    this.doctor = this.$route.params.doctor;
    this.data = this.$route.params.data;
    this.position = this.$route.params.position;
    this.adres1 = this.$route.params.adres1;
    this.adres2 = this.$route.params.adres2;
    this.information = this.$route.params.information;
    this.type = this.$route.params.type;
    this.cena = this.$route.params.cena;
    // check if visit datetime is before now
    var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
    var visitDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(this.$route.params.data));
    this.isBeforeVisit = now.isBefore(visitDate);
    var getDomain = location.protocol + '//' + location.host;
    this.$http.get(getDomain + '/config.php').then(function (response) {
      var resp = response.data;
      _this.platnoscOnlineLink = resp.platnoscOnlineLink;
      _this.platnoscOnline = resp.platnoscOnline;
    }).catch(function (errors) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
    });
  },
  methods: {
    fillQuestionnaire: function fillQuestionnaire() {
      var visitId = this.$route.params.visitId;
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
      }
      var getDomain = location.protocol + '//' + location.host;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: getDomain + '/ankieta/parser.php',
        method: 'POST',
        contentType: 'application/json',
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#visit-questionnaire-box').html(data);
          // asign all first radios
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()(':radio[value=0]').each(function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).attr('checked', true);
          });
          // send ankieta
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#sendQform').click(function () {
            // send ankieta to helper
            var formData = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#qForm').serializeArray();
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
              url: getDomain + '/ankieta/helper.php',
              method: 'POST',
              data: formData,
              success: function success(data) {
                // send ankieta to API
                var responseObj = JSON.parse(data);
                responseObj.input.TOKEN = token;
                responseObj.input.id = visitId;
                __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
                  url: '/api.php?url=setAnkieta',
                  method: 'POST',
                  data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(responseObj),
                  contentType: 'application/json',
                  success: function success(data) {
                    __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Ankieta wysłana. Dziękujemy.');
                    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#visit-questionnaire').html(' ');
                    this.$router.push('dashboard/main');
                  },
                  error: function error(_error) {
                    alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_error));
                  }
                });
              },
              error: function error(_error2) {
                alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_error2));
              }
            });
          });
        },
        error: function error(_error3) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_error3));
        }
      });
    },
    cancelVisit: function cancelVisit() {
      var _this2 = this;

      var visitId = this.$route.params.visitId;
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var cancelVisitMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'id': visitId, 'result': '' } } };
        this.$http.post('/api.php?url=cancelVisitREJ', cancelVisitMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.notification("<span uk-icon='icon: check'></span> Wizyta została odwołana.", 'success');
          _this2.$router.push('dashboard/main');
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        });
      }
    },
    changeVisit: function changeVisit() {
      var _this3 = this;

      // cancelVisit
      var visitId = this.$route.params.visitId;
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var cancelVisitMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'id': visitId, 'result': '' } } };
        this.$http.post('/api.php?url=cancelVisitREJ', cancelVisitMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          // changeVisit
          var getDomain = location.protocol + '//' + location.host;
          _this3.$http.get(getDomain + '/config.php').then(function (response) {
            var resp = response.data;
            if (_this3.$cookie.get('aut')) {
              var token = _this3.$cookie.get('aut');
              document.location.href = resp.przenoszenieWizytyLink + token;
            }
          }).catch(function (errors) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
          });
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        });
      }
    },
    orderDoc: function orderDoc(docId) {
      var visitId = this.$route.params.visitId;
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var orderDocumentMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'IDKorSzablon': docId, 'IDRejestracja': visitId } } };
        this.$http.post('/api.php?url=orderDocument', orderDocumentMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var resp = response.data;
          var ordered = resp.d.status;
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ordered) === '"OK"') {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.alert('Prośba o zamówienie dokumentu została wysłana.');
            // UIkit.notification("<span uk-icon='icon: check'></span>Prośba o zamówienie dokumentu została wysłana.", 'success')
          } else {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dokument został juz zamówiony...');
          }
          // UIkit.notification("<span uk-icon='icon: check'></span>Prośba o zamówienie dokumentu została wysłana.", 'success')
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dokument został juz zamówiony.');
        });
      }
    },
    getDoc: function getDoc(docId) {
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var getDocumentMetod = { 'input': { 'status': '', 'TOKEN': token, 'id': docId } };
        this.$http.post('/api.php?url=getDocument', getDocumentMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var odp = response.data;
          var fileString = odp.d.data;
          var fileName = odp.d.fileName;
          var contentType = odp.d.content;
          var ext = odp.d.ext;
          var doc = contentType + ';base64,' + fileString;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<a id="file_' + docId + '" style="display:none" href="data:' + doc + '" download="' + docId + '_' + fileName + '.' + ext + '"></a>').appendTo('body');
          var elem = document.getElementById('file_' + docId);
          elem.click();
        }).catch(function (errors) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors.status) === '500') {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Serwer tymczasowo nie czynny');
          } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors.status) === '404') {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem z pobraniem pliku');
          } else {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak... Kod: ' + errors.status);
          }
        });
      }
    },
    exitVisit: function exitVisit(save) {
      save === true && this.saveVisit();
      this.$router.push('main');
    },
    saveVisit: function saveVisit() {
      __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.notification("<span uk-icon='icon: check'></span> Zmiany zostały zapisane.", 'success');
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    config: function config() {
      return this.$parent.config;
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menuRejestracjaLink: '',
      logoLink: ''
    };
  },

  computed: {
    config: function config() {
      return this.$parent.config;
    }
  },
  methods: {
    refreshMain: function refreshMain($event) {
      this.$root.$emit('refreshMain');
    }
  },
  mounted: function mounted() {
    var _this = this;

    var getDomain = location.protocol + '//' + location.host;
    this.$http.get(getDomain + '/config.php').then(function (response) {
      var resp = response.data;
      if (_this.$cookie.get('aut')) {
        var token = _this.$cookie.get('aut');
        _this.menuRejestracjaLink = resp.menuRejestracjaLink + token;
        _this.logoLink = resp.logoLink;
      }
    }).catch(function (errors) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
    });
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notifications',
  data: function data() {
    return {
      notifications: [{
        'title': '',
        'messagetxt': '',
        'data': '',
        'author': '',
        'id': '',
        'read': ''
      }]
    };
  },

  mounted: function mounted() {
    this.loadData();
    this.interval = setInterval(function () {
      this.loadData();
    }.bind(this), 30000);
  },
  methods: {
    MarkAsRead: function MarkAsRead(id) {
      var _this = this;

      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var markReadMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'id': id } }
          // TODO: API URL z XML
        };this.$http.post('/api.php?url=markRead', markReadMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          _this.loadData();
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        });
      }
    },
    isRead: function isRead(notification) {
      if (notification.read === false) {
        return true;
      } else {
        return false;
      }
    },
    OpenModal: function OpenModal(id) {
      __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal('#see-more-modal-' + id).show();
    },

    loadData: function loadData() {
      var _this2 = this;

      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut');
        var getMessagesMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'reservation_id': null } }
          // TODO: API URL z XML
        };this.$http.post('/api.php?url=getMessages', getMessagesMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var resp = response.data;
          var notifications = resp.d.data;
          _this2.notifications = notifications;
        }).catch(function (errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        });
      }
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var VueInputMask = __webpack_require__(224).default;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(VueInputMask);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      logging_in: false,
      credentials: {
        ID: '',
        pass: '',
        terms: false,
        passNew_2: '',
        passNew: ''
      },
      remember: {
        ID: '',
        email: '',
        phoneNumber: '',
        pesel: ''
      },
      error: '',
      contactMail: '',
      contactFromMail: '',
      error_terms: false,
      error_box: false,
      error_box_mismatch: false,
      error_box_characters: false,
      error_box_empty: false,
      loginShow: true
    };
  },

  computed: {
    config: function config() {
      return this.$parent.config;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$cookie.get('aut')) {
      var token = this.$cookie.get('aut');
      var refreshTokenMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token, 'reservation_id': null } } };
      this.$http.post('/api.php?url=refreshToken', refreshTokenMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        _this.$cookie.set('aut', token, { expires: '20m' });
        _this.$router.replace({ path: '//dashboard' });
      }).catch(function (errors) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
        _this.$cookie.delete('aut');
      });
    }
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passinp').keyup(function (event) {
      if (event.keyCode === 13) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#loginbtn').click();
      }
    });
    if (this.$route.params.id !== undefined) {
      // Ustawienie hasła
      this.loginShow = false;
      this.credentials.ID = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#newpassbtn').hide();
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#hashnewpassbtn').show();
    }
    this.$http.get('/config.php').then(function (response) {
      var resp = response.data;
      _this.contactMail = resp.emailZzalacznikiemAdres;
      _this.contactFromMail = resp.emailZzalacznikiemFrom;
    }).catch(function (errors) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
    });
    var vm = this;
    var logoConfInterval = setInterval(function () {
      if (vm.config.logo_width !== undefined) {
        clearInterval(logoConfInterval);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#logo').css('width', vm.config.logo_width);
      }
    }, 100);
  },
  methods: {
    login: function login(ID, pass) {
      var _this2 = this;

      this.logging_in = true;
      this.error_box = false;
      this.error_box_characters = false;
      this.error_box_mismatch = false;
      this.error_box_empty = false;
      if (this.credentials.ID === '' || this.credentials.pass === '') {
        this.error_box_empty = true;
        this.logging_in = false;
        return false;
      }
      var credentials = {
        input: {
          status: '',
          data: {
            ID: this.credentials.ID,
            pass: this.credentials.pass
          }
        }
        // TOOD: XML
      };this.$http.post('/api.php?url=login', credentials, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        var odp = response.data;
        var token = odp.d.data.TOKEN;
        var cdata = { email: odp.d.data.email, name: odp.d.data.name, lastname: odp.d.data.lastname, id: _this2.credentials.ID };
        var firstLogin = odp.d.data.first;
        // add client data
        _this2.$cookie.set('cdata', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cdata), { expires: '1D' });
        if (firstLogin === false) {
          // kolejne logowanie
          _this2.$cookie.set('aut', token, { expires: '20m' });
          localStorage.setItem('unison_id', response.data.d.data.IDPacjent);
          if (cdata.email === '') {
            var modal = __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal('#email-patient-reminder-modal');
            modal.show();
          }
        } else {
          // pierwsze logowanie - wymagana zmiana hasla
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Logujesz się pierwszy raz. Prosimy o zmiane hasła. Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.');
          _this2.loginShow = false;
        }
        if (_this2.$cookie.get('aut')) {
          _this2.$router.replace({ path: '//dashboard' });
        }
        _this2.logging_in = false;
      }).catch(function (errors) {
        if (errors.status === 504 || errors.status === 500) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem z logowaniem, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.');
        } else {
          _this2.error_box = true;
        }
        _this2.logging_in = false;
      });
    },
    NewPass: function NewPass() {
      var _this3 = this;

      this.error_box = false;
      this.error_box_characters = false;
      this.error_box_mismatch = false;
      this.error_terms = false;
      if (this.credentials.passNew) {
        var PID = this.credentials.ID;
        var Ppass = this.credentials.pass;
        var PpassNew = this.credentials.passNew;
        var changePasswordInput = { 'input': { 'status': '', 'data': { 'ID': PID, 'pass': Ppass, 'new_pass': PpassNew } } };
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          this.error_box_mismatch = true;
        } else if (!this.credentials.terms) {
          this.error_terms = true;
        } else if (reg.test(PpassNew)) {
          // new pass validate ok
          // TOOD: XML
          this.$http.post('/api.php?url=changePassword', changePasswordInput, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
            // var odp = response.data
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Hasło zostało zmienione poprawnie. Zaraz zostaniesz przekierowany do swojego konta.');
            _this3.credentials.pass = PpassNew;
            _this3.login();
            // this.$router.push('main')
            // }
          }).catch(function (errors) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errors);
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem przy zmianie hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.');
          });
        } else {
          this.error_box_characters = true;
          // UIkit.modal.alert('Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.')
        }
      } else {
        this.error_box_characters = true;
        // UIkit.modal.alert('Wpisz nowe hasło')
      }
    },
    HashNewPass: function HashNewPass() {
      var _this4 = this;

      this.error_box = false;
      this.error_box_characters = false;
      this.error_box_mismatch = false;
      this.error_terms = false;
      if (this.credentials.passNew) {
        var PpassNew = this.credentials.passNew;
        var hashLoginRequest = {
          'request': {
            'Id': this.$route.params.id,
            'NewPass': this.credentials.passNew,
            'Hash': this.$route.params.hash,
            'Terms': this.credentials.terms,
            'TermsContent': this.config.clinic_info.terms
          }
        };
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          this.error_box_mismatch = true;
        } else if (!this.credentials.terms) {
          this.error_terms = true;
        } else if (reg.test(PpassNew)) {
          // new pass validate ok
          this.$http.post('/api.php?url=HashLogin', hashLoginRequest, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
            var r = response.data.d;
            if (r.IsSuccess) {
              __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Hasło zostało ustawione poprawnie. Zaraz zostaniesz przekierowany do swojego konta.');
              _this4.credentials.pass = _this4.credentials.passNew;
              console.log(_this4);
              _this4.login();
            } else {
              __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem przy ustawianiu hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.');
            }
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
          }).catch(function (err) {
            if (err.status === 404) {
              __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Nie znaleziono pacjenta, lub wskazany link wygasł.');
            } else {
              __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Wystąpił problem przy ustawianiu hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.');
            }
          });
        } else {
          this.error_box_characters = true;
        }
      } else {
        this.error_box_characters = true;
      }
    },
    setEmail: function setEmail() {
      var _this5 = this;

      var vm = this;
      var regex = /^.+@.+$/;
      if (vm.remember.email === '' || !regex.test(vm.remember.email)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#email-patient-reminder-modal #error_empty_email').show();
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#email-patient-reminder-modal #error_empty_email').hide();
        var token = this.$cookie.get('aut');
        var data = { 'request': { 'Id': vm.credentials.ID, 'Token': token, 'Email': vm.remember.email } };
        vm.$http.post('/api.php?url=SetEmail', data, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var cdata = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.parseJSON(_this5.$cookie.get('cdata'));
          cdata.email = vm.remember.email;
          _this5.$cookie.set('cdata', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cdata), { expires: '1D' });
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dziękujemy.');
        }).catch(function (err) {
          if (err.status === 400) {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Nieprawidłowe dane.');
          } else {
            __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
          }
        });
      }
    },
    firstLogin: function firstLogin() {
      var vm = this;
      vm.error_box = false;
      vm.error_box_characters = false;
      vm.error_box_mismatch = false;
      var data = { 'request': { 'Id': vm.credentials.ID } };
      vm.$http.post('/api.php?url=FirstLogin', data, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dziękujemy. Na Twój numer telefonu zostało wysłane tymczasowe hasło.');
        vm.credentials.pass = '';
        vm.remember.phoneNumber = '';
      }).catch(function (err) {
        vm.credentials.ID = '';
        if (err.status === 400) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Nieprawidłowe dane.');
        } else if (err.status === 403) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Hasło zostało już wcześniej zmienione');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
        }
      });
    },
    rememberActionID: function rememberActionID() {
      var vm = this;
      vm.error_box = false;
      vm.error_box_characters = false;
      vm.error_box_mismatch = false;
      var data = { 'request': { 'phone': vm.remember.phoneNumber, 'pesel': vm.remember.pesel } };
      vm.$http.post('/api.php?url=RemindId', data, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Dziękujemy. Na Twój numer telefonu zostało wysłane twoje ID pacjenta.');
        vm.credentials.pass = '';
        vm.credentials.ID = '';
        vm.remember.phoneNumber = '';
        vm.remember.pesel = '';
      }).catch(function (err) {
        if (err.status === 400) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Błędnie wprowadzony numer telefonu lub PESEL.');
        } else if (err.status === 404) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Błędnie wprowadzony numer telefonu lub PESEL.');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
        }
        vm.remember.phoneNumber = '';
        vm.remember.pesel = '';
      });
    },
    rememberAction: function rememberAction() {
      var vm = this;
      vm.error_box = false;
      vm.error_box_characters = false;
      vm.error_box_mismatch = false;
      var tryResetMetod = { 'input': { 'ID': vm.remember.ID, 'mail': vm.remember.email } };
      vm.$http.post('/api.php?url=tryReset', tryResetMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Niedługo dostaniesz hasło tymczasowe w wiadomości Email.');
        vm.credentials.pass = '';
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passinp').attr('placeholder', 'Wpisz hasło otrzymane w wiadomości Email');
      }).catch(function (errors) {
        // alert(JSON.stringify(errors))
        if (errors.status === 404) {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Zły login lub email');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_uikit___default.a.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką');
        }
      });
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer',
  data: function data() {
    return {};
  },

  computed: {
    config: function config() {
      return this.$parent.config;
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'hash': '',
      'info': ''
    };
  },

  computed: {
    config: function config() {
      return this.$parent.config;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.hash = this.$route.params.hash;
    this.info = 'Dziękujemy. Nowe hasło zostanie wysłane do Ciebie przez SMS.';
    var ResetPassMetod = { 'input': { 'hash': this.hash } };
    this.$http.post('/api.php?url=ResetPass', ResetPassMetod, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
      _this.info = 'Dziękujemy. Nowe hasło zostanie wysłane do Ciebie przez SMS.';
    }).catch(function (errors) {
      _this.info = 'Coś poszło nie tak...';
    });
  }
});

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 17,
	"./af.js": 17,
	"./ar": 24,
	"./ar-dz": 18,
	"./ar-dz.js": 18,
	"./ar-kw": 19,
	"./ar-kw.js": 19,
	"./ar-ly": 20,
	"./ar-ly.js": 20,
	"./ar-ma": 21,
	"./ar-ma.js": 21,
	"./ar-sa": 22,
	"./ar-sa.js": 22,
	"./ar-tn": 23,
	"./ar-tn.js": 23,
	"./ar.js": 24,
	"./az": 25,
	"./az.js": 25,
	"./be": 26,
	"./be.js": 26,
	"./bg": 27,
	"./bg.js": 27,
	"./bm": 28,
	"./bm.js": 28,
	"./bn": 30,
	"./bn-bd": 29,
	"./bn-bd.js": 29,
	"./bn.js": 30,
	"./bo": 31,
	"./bo.js": 31,
	"./br": 32,
	"./br.js": 32,
	"./bs": 33,
	"./bs.js": 33,
	"./ca": 34,
	"./ca.js": 34,
	"./cs": 35,
	"./cs.js": 35,
	"./cv": 36,
	"./cv.js": 36,
	"./cy": 37,
	"./cy.js": 37,
	"./da": 38,
	"./da.js": 38,
	"./de": 41,
	"./de-at": 39,
	"./de-at.js": 39,
	"./de-ch": 40,
	"./de-ch.js": 40,
	"./de.js": 41,
	"./dv": 42,
	"./dv.js": 42,
	"./el": 43,
	"./el.js": 43,
	"./en-au": 44,
	"./en-au.js": 44,
	"./en-ca": 45,
	"./en-ca.js": 45,
	"./en-gb": 46,
	"./en-gb.js": 46,
	"./en-ie": 47,
	"./en-ie.js": 47,
	"./en-il": 48,
	"./en-il.js": 48,
	"./en-in": 49,
	"./en-in.js": 49,
	"./en-nz": 50,
	"./en-nz.js": 50,
	"./en-sg": 51,
	"./en-sg.js": 51,
	"./eo": 52,
	"./eo.js": 52,
	"./es": 56,
	"./es-do": 53,
	"./es-do.js": 53,
	"./es-mx": 54,
	"./es-mx.js": 54,
	"./es-us": 55,
	"./es-us.js": 55,
	"./es.js": 56,
	"./et": 57,
	"./et.js": 57,
	"./eu": 58,
	"./eu.js": 58,
	"./fa": 59,
	"./fa.js": 59,
	"./fi": 60,
	"./fi.js": 60,
	"./fil": 61,
	"./fil.js": 61,
	"./fo": 62,
	"./fo.js": 62,
	"./fr": 65,
	"./fr-ca": 63,
	"./fr-ca.js": 63,
	"./fr-ch": 64,
	"./fr-ch.js": 64,
	"./fr.js": 65,
	"./fy": 66,
	"./fy.js": 66,
	"./ga": 67,
	"./ga.js": 67,
	"./gd": 68,
	"./gd.js": 68,
	"./gl": 69,
	"./gl.js": 69,
	"./gom-deva": 70,
	"./gom-deva.js": 70,
	"./gom-latn": 71,
	"./gom-latn.js": 71,
	"./gu": 72,
	"./gu.js": 72,
	"./he": 73,
	"./he.js": 73,
	"./hi": 74,
	"./hi.js": 74,
	"./hr": 75,
	"./hr.js": 75,
	"./hu": 76,
	"./hu.js": 76,
	"./hy-am": 77,
	"./hy-am.js": 77,
	"./id": 78,
	"./id.js": 78,
	"./is": 79,
	"./is.js": 79,
	"./it": 81,
	"./it-ch": 80,
	"./it-ch.js": 80,
	"./it.js": 81,
	"./ja": 82,
	"./ja.js": 82,
	"./jv": 83,
	"./jv.js": 83,
	"./ka": 84,
	"./ka.js": 84,
	"./kk": 85,
	"./kk.js": 85,
	"./km": 86,
	"./km.js": 86,
	"./kn": 87,
	"./kn.js": 87,
	"./ko": 88,
	"./ko.js": 88,
	"./ku": 89,
	"./ku.js": 89,
	"./ky": 90,
	"./ky.js": 90,
	"./lb": 91,
	"./lb.js": 91,
	"./lo": 92,
	"./lo.js": 92,
	"./lt": 93,
	"./lt.js": 93,
	"./lv": 94,
	"./lv.js": 94,
	"./me": 95,
	"./me.js": 95,
	"./mi": 96,
	"./mi.js": 96,
	"./mk": 97,
	"./mk.js": 97,
	"./ml": 98,
	"./ml.js": 98,
	"./mn": 99,
	"./mn.js": 99,
	"./mr": 100,
	"./mr.js": 100,
	"./ms": 102,
	"./ms-my": 101,
	"./ms-my.js": 101,
	"./ms.js": 102,
	"./mt": 103,
	"./mt.js": 103,
	"./my": 104,
	"./my.js": 104,
	"./nb": 105,
	"./nb.js": 105,
	"./ne": 106,
	"./ne.js": 106,
	"./nl": 108,
	"./nl-be": 107,
	"./nl-be.js": 107,
	"./nl.js": 108,
	"./nn": 109,
	"./nn.js": 109,
	"./oc-lnc": 110,
	"./oc-lnc.js": 110,
	"./pa-in": 111,
	"./pa-in.js": 111,
	"./pl": 112,
	"./pl.js": 112,
	"./pt": 114,
	"./pt-br": 113,
	"./pt-br.js": 113,
	"./pt.js": 114,
	"./ro": 115,
	"./ro.js": 115,
	"./ru": 116,
	"./ru.js": 116,
	"./sd": 117,
	"./sd.js": 117,
	"./se": 118,
	"./se.js": 118,
	"./si": 119,
	"./si.js": 119,
	"./sk": 120,
	"./sk.js": 120,
	"./sl": 121,
	"./sl.js": 121,
	"./sq": 122,
	"./sq.js": 122,
	"./sr": 124,
	"./sr-cyrl": 123,
	"./sr-cyrl.js": 123,
	"./sr.js": 124,
	"./ss": 125,
	"./ss.js": 125,
	"./sv": 126,
	"./sv.js": 126,
	"./sw": 127,
	"./sw.js": 127,
	"./ta": 128,
	"./ta.js": 128,
	"./te": 129,
	"./te.js": 129,
	"./tet": 130,
	"./tet.js": 130,
	"./tg": 131,
	"./tg.js": 131,
	"./th": 132,
	"./th.js": 132,
	"./tk": 133,
	"./tk.js": 133,
	"./tl-ph": 134,
	"./tl-ph.js": 134,
	"./tlh": 135,
	"./tlh.js": 135,
	"./tr": 136,
	"./tr.js": 136,
	"./tzl": 137,
	"./tzl.js": 137,
	"./tzm": 139,
	"./tzm-latn": 138,
	"./tzm-latn.js": 138,
	"./tzm.js": 139,
	"./ug-cn": 140,
	"./ug-cn.js": 140,
	"./uk": 141,
	"./uk.js": 141,
	"./ur": 142,
	"./ur.js": 142,
	"./uz": 144,
	"./uz-latn": 143,
	"./uz-latn.js": 143,
	"./uz.js": 144,
	"./vi": 145,
	"./vi.js": 145,
	"./x-pseudo": 146,
	"./x-pseudo.js": 146,
	"./yo": 147,
	"./yo.js": 147,
	"./zh-cn": 148,
	"./zh-cn.js": 148,
	"./zh-hk": 149,
	"./zh-hk.js": 149,
	"./zh-mo": 150,
	"./zh-mo.js": 150,
	"./zh-tw": 151,
	"./zh-tw.js": 151
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
  __webpack_require__(213)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
  __webpack_require__(204)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16041882",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ef0cfb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
  __webpack_require__(216)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8657372",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-577c9ead",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32a4d8ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5409104",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52d3a5ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd845434",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-233df080",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-663f4b46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-child-width-expand@m",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Kartoteka pacjenta")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Nazwisko))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Imie))])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Imie2))])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.PESEL))])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.DataUr))])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.MiejsceUr))])])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.TelKom))])])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Tel))])])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Email))])])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top",
    attrs: {
      "uk-toggle": "target: #pass-change-modal",
      "type": "button"
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top",
    attrs: {
      "uk-toggle": "target: #email-patient-reminder-modal",
      "type": "button"
    }
  }, [_vm._v("Edytuj Email")]), _vm._v(" "), _c('router-link', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-top",
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_vm._v("Chcę poprawić swoje dane")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Adres zameldowania")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.KodPocztowy) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Poczta))])])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Miejscowosc))])])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.UlicaAlejaPlac) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Ulica))])])]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrDomu))])])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrMieszkania))])])]), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Kraj))])])])]), _vm._v(" "), _c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Adres korespondencyjny")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(15), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.KodPocztowy2) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Poczta2))])])]), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Miejscowosc2))])])]), _vm._v(" "), _c('tr', [_vm._m(17), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.UlicaAlejaPlac2) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Ulica2))])])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrDomu2))])])]), _vm._v(" "), _c('tr', [_vm._m(19), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrMieszkania2))])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Dodatkowe uprawnienia")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, _vm._l((_vm.NFZElements), function(element) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(element.Opis))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(element.Wartosc))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "email-patient-reminder-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana adresu email")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Twój aktualny email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEmail
    }
  }, [_vm._v("Zapisz")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pass-change-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana hasła")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew),
      expression: "credentials.passNew"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew_2),
      expression: "credentials.passNew_2"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Powtórz nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew_2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setPass
    }
  }, [_vm._v("Zapisz")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Nazwisko")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Imię")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Drugie imię")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("PESEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Data urodzenia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejsce urodzenia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Telefon kom.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Telefon dom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kod. Poczta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejscowość")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Ulica")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer domu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer lokalu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kraj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kod. Poczta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejscowość")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Ulica")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer domu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer lokalu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_empty_email",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź poprawny adres email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_mismatch",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_characters",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_empty",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić hasło.")])])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-wrap"
  }, [_c('div', {
    staticClass: "uk-width-1-2@m",
    attrs: {
      "id": "visit-notifications"
    }
  }, [_c('h4', [_vm._v("Wyślij wiadomość")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin uk-width-3-4@m"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTxt),
      expression: "messageTxt"
    }],
    staticClass: "uk-textarea",
    attrs: {
      "rows": "5",
      "placeholder": "Wpisz wiadomość",
      "id": "messageInp"
    },
    domProps: {
      "value": (_vm.messageTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageTxt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    attrs: {
      "id": "selectedFiles"
    }
  }, _vm._l((_vm.files), function(file, key) {
    return _c('div', {
      staticClass: "file-listing"
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n            "), _c('span', {
      staticClass: "uk-label uk-label-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(key)
        }
      }
    }, [_vm._v("Usuń")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    attrs: {
      "uk-form-custom": ""
    }
  }, [_c('input', {
    ref: "files",
    attrs: {
      "type": "file",
      "id": "files",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "type": "button",
      "tabindex": "-1"
    }
  }, [_vm._v("Dodaj załączniki")])]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "disabled": this.messageTxt.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("Wyślij")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-overflow-auto",
    attrs: {
      "id": "visit-documents"
    }
  }, [_c('h4'), _vm._v(" "), _c('carousel', {
    attrs: {
      "auto": 5000,
      "watch-items": _vm.list
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('carousel-item', {
      key: item.url
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-2-2@m uk-margin-top",
    attrs: {
      "id": "visit-questionnaire"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_vm._v("Nazwa i adresy kliniki oraz informację")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Nazwa kliniki:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Adres:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.street) + ", " + _vm._s(_vm.config.clinic_info.postal_code) + ", " + _vm._s(_vm.config.clinic_info.city))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Opis:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.description))])])])])
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Login') ? _c('footer', {
    staticClass: "uk-container uk-width uk-flex uk-flex-wrap uk-flex-end uk-flex"
  }, [_c('div', {
    staticClass: "uk-width uk-text-center",
    domProps: {
      "textContent": _vm._s(_vm.config.footer_text)
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "uk-container uk-container-small uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom"
  }, [_c('div', {
    staticClass: "uk-width uk-text-center",
    domProps: {
      "textContent": _vm._s(_vm.config.footer_text)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.config.footer_text) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap",
    attrs: {
      "id": "notifications"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notificaions-holder uk-width"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "notification uk-width uk-margin-bottom uk-margin-remove-top uk-box-shadow-small uk-box-shadow-hover-large uk-padding uk-grid uk-margin-remove-left uk-padding-small",
      class: {
        unread: _vm.isRead(notification)
      }
    }, [_c('span', {
      staticClass: "uk-flex uk-flex-middle uk-width-1-6 uk-padding-remove-horizontal",
      attrs: {
        "uk-icon": "icon: info; ratio: 1.5;"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uk-width-5-6 uk-padding-remove-horizontal"
    }, [_c('article', {
      staticClass: "notification-title uk-width",
      on: {
        "click": function($event) {
          return _vm.OpenModal(notification.id)
        }
      }
    }, [_c('h4', {
      staticClass: "text-ellipsis two-line",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('span', {
      staticClass: "text-ellipsis three-line"
    }, [_vm._v(_vm._s(notification.messagetxt))])]), _vm._v(" "), _c('footer', {
      staticClass: "uk-link-muted uk-width uk-padding-remove-horizontal uk-margin-small-top"
    }, [_c('span', {
      staticClass: "time-added"
    }, [_vm._v("Dodane " + _vm._s(_vm._f("formatDatefrom")(notification.data)))]), _vm._v("\n          |\n          "), _c('a', {
      staticClass: "see-more",
      on: {
        "click": function($event) {
          return _vm.OpenModal(notification.id)
        }
      }
    }, [_vm._v("Zobacz cały komunikat")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": 'see-more-modal-' + notification.id,
        "uk-modal": ""
      }
    }, [_c('div', {
      staticClass: "uk-modal-dialog uk-modal-body"
    }, [_c('h2', {
      staticClass: "uk-modal-title"
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(notification.messagetxt))]), _vm._v(" "), _c('p', {
      staticClass: "uk-text-right"
    }, [_c('button', {
      staticClass: "uk-button uk-button-default uk-modal-close",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Zamknij")]), _vm._v(" "), (notification.read === false) ? _c('button', {
      staticClass: "uk-button uk-button-danger uk-modal-close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.MarkAsRead(notification.id)
        }
      }
    }, [_vm._v("Przeczytane")]) : _vm._e()])])])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "uk-width uk-margin-remove uk-padding-remove uk-heading-line"
  }, [_c('h3', [_vm._v("Komunikaty")])])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "uk-width uk-margin-remove uk-padding-remove"
  }, [_c('h3', {
    staticClass: "uk-flex-inline"
  }, [_vm._v("Status wizyty")]), _vm._v(" "), (_vm.status === 'zarejestrowana') ? _c('span', {
    staticClass: "uk-label uk-label-primary",
    staticStyle: {
      "margin-top": "-5px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _c('span', {
    staticClass: "uk-label uk-label-warning",
    staticStyle: {
      "margin-top": "-5px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), (_vm.status === 'zarejestrowana' && _vm.isBeforeVisit) ? _c('div', {
    staticClass: "float-right"
  }, [(_vm.platnoscOnline === 'enable') ? _c('a', {
    attrs: {
      "href": _vm.platnoscOnlineLink,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small"
  }, [_vm._v("Zapłać online")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small",
    attrs: {
      "uk-toggle": "target: #change-visit-date-modal"
    }
  }, [_vm._v("Zmień termin wizyty")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-button-small",
    attrs: {
      "uk-toggle": "target: #cancel-visit-modal"
    }
  }, [_vm._v("Odwołaj wizytę")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-wrap"
  }, [_c('div', {
    staticClass: "uk-width-1-2@m",
    attrs: {
      "id": "visit-notifications"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("Szczegóły wizyty")]), _vm._v(" "), _c('strong', [_vm._v("Powód wizyty:")]), _vm._v(" " + _vm._s(_vm.reason)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Lekarz:")]), _vm._v(" " + _vm._s(_vm.doctor)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Termin:")]), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.data))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Godzina:")]), _vm._v(" " + _vm._s(_vm._f("formatTime")(_vm.data))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Lokalizacja wizyty:")]), _vm._v(" " + _vm._s(_vm.adres1) + ", " + _vm._s(_vm.adres2)), _c('br'), _vm._v(" "), _c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.information !== ''),
      expression: "information !== ''"
    }]
  }, [_vm._v("Jak się przygotować do wizyty:")]), _vm._v(" " + _vm._s(_vm.information)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Rodzaj wizyty:")]), _vm._v(" " + _vm._s(_vm.type === 'PLN' ? 'komercyjna' : (_vm.type === 'NFZ' ? 'refundowana NFZ' : 'bezpłatna'))), _c('br'), _vm._v(" "), (_vm.type === 'PLN') ? _c('span', [_c('strong', [_vm._v("Cena:")]), _vm._v(" " + _vm._s(_vm.cena))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.position === '-1') ? _c('strong') : _c('strong', [_vm._v("Numer w kolejce:")]), _vm._v(" "), (_vm.position === '-1') ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.position))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "uk-wdith"
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-overflow-auto",
    attrs: {
      "id": "visit-documents"
    }
  }, [_c('h4', [_vm._v("Dokumentacja medyczna do pobrania")]), _vm._v(" "), (_vm.documentsLoading) ? _c('div', [_c('div', {
    attrs: {
      "uk-spinner": ""
    }
  })]) : _c('div', [(_vm.documents && _vm.documents !== '') ? _c('div', [_c('table', {
    staticClass: "uk-table uk-table-middle uk-table-divider uk-table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.documents), function(document) {
    return _c('tr', [_c('td', [(document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0) ? _c('span', {
      staticClass: "uk-label uk-label-success",
      staticStyle: {
        "background-color": "#2ea278"
      }
    }, [_vm._v("Gotowy do pobrania")]) : (document.IDportal === 4 && document.IDDokumenty !== 0) ? _c('span', {
      staticClass: "uk-label uk-label-primary"
    }, [_vm._v("Odbiór osobisty")]) : _vm._e(), _vm._v(" "), (document.IDportal === 2 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : (document.IDportal === 3 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : (document.IDportal === 4 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(document.fileName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "padding-right": "0px"
      }
    }, [(document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0) ? _c('button', {
      staticClass: "uk-button uk-button-primary uk-button-small pull-right",
      on: {
        "click": function($event) {
          return _vm.getDoc(document.IDDokumenty)
        }
      }
    }, [_vm._v("Pobierz")]) : (document.IDportal === 4 && document.IDDokumenty !== 0) ? _c('button', {
      staticClass: "uk-button uk-button-primary uk-button-small pull-right",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Pobierz")]) : _vm._e(), _vm._v(" "), (document.IDportal === 2 && document.IDDokumenty === 0 || document.IDportal === 3 && document.IDDokumenty === 0 || document.IDportal === 4 && document.IDDokumenty === 0) ? _c('button', {
      staticClass: "uk-button uk-button-default uk-button-small pull-right",
      on: {
        "click": function($event) {
          return _vm.orderDoc(document.IDKorSzablon)
        }
      }
    }, [_vm._v("Zamów")]) : _vm._e()])])
  }), 0)])]) : _c('div', [_vm._v("\n          Brak dokumentów do pobrania\n        ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ankietaPar === 1),
      expression: "ankietaPar === 1"
    }],
    staticClass: "uk-width-2-2@m uk-margin-top",
    attrs: {
      "id": "visit-questionnaire"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_vm._v("Ankieta przed wizytą")]), _vm._v(" "), (_vm.ankietaPar !== 1) ? _c('strong', [_vm._v(_vm._s(_vm.ankietaTxt))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "visit-questionnaire-box"
    }
  }, [(_vm.ankietaPar === 1) ? _c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.fillQuestionnaire
    }
  }, [_vm._v("Wypełnij ankiete")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "change-visit-date-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana terminu wizyty")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz zmienić termin wizyty? Dotychczasowy termin wizyty zostanie anulowany.")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Nie")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeVisit
    }
  }, [_vm._v("Tak")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cancel-visit-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Odwołanie wizyty")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz odwołać tą wizytę?")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Nie")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelVisit
    }
  }, [_vm._v("Tak")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "exit-without-save-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Wyjście z wizyty bez zapisu")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz wyjść z widoku wizyty bez wcześniejczego zapisania zmian?")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitVisit(true)
      }
    }
  }, [_vm._v("Zapisz zmiany i wyjdź")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exitVisit
    }
  }, [_vm._v("Tak")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "uk-width-small"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Opis")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-middle",
    attrs: {
      "id": "login-page-container"
    }
  }, [_c('div', {
    staticClass: "uk-width uk-flex uk-flex-wrap uk-flex-center"
  }, [_c('header', {
    staticClass: "uk-width uk-text-center uk-text-middle"
  }, [_c('img', {
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-section uk-section-primary uk-light uk-width-1-2@m",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          Resetowanie hasła\n        ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_vm._v("\n            " + _vm._s(_vm.info) + "\n          ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1-2@s",
    attrs: {
      "id": "left-menu"
    }
  }, [_c('h3', {
    staticClass: "uk-heading-line uk-text-center"
  }, [_c('span', [_vm._v("Menu")])]), _vm._v(" "), _c('ul', {
    staticClass: "uk-nav-primary uk-nav-parent-icon",
    attrs: {
      "uk-nav": ""
    }
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moje wizyty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("E-rejestracja")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moje dane")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dokumenty do pobrania")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Strona kliniki LENS")])])])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-remove-top"
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('div', {
    staticClass: "uk-grid uk-margin-right"
  }, [_c('div', [_c('a', {
    staticClass: "uk-navbar-item uk-logo",
    attrs: {
      "href": _vm.logoLink
    }
  }, [_c('img', {
    staticStyle: {
      "height": "60px"
    },
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('div', {
    staticClass: "uk-flex"
  }, [_c('h3', {
    staticClass: "uk-col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "uk-h6 uk-text-middle uk-visible@m",
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie.",
      "uk-tooltip": "pos: bottom"
    }
  }, [_vm._v("Witaj " + _vm._s(_vm.firstName) + " " + _vm._s(_vm.LastName) + ". Sesja wygaśnie za " + _vm._s(_vm.sessionValidToText))])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex"
  }, [_c('router-link', {
    staticClass: "uk-margin-auto-left",
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small uk-margin-auto-left",
    staticStyle: {
      "float": "left",
      "display": "none"
    },
    attrs: {
      "id": "backbtn"
    }
  }, [_vm._v("Wróć do listy wizyt")])])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "uk-wdith uk-margin-remove-top uk-divider-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-container uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom page-wrapper"
  }, [_c('div', {
    staticClass: "uk-width"
  }, [_c('div', {
    staticClass: "uk-grid"
  }, [_c('notifications', {
    staticClass: "uk-background-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap session-info-wrap"
  }, [_c('div', {
    attrs: {
      "id": "sliderMain"
    }
  }, [_c('carousel', {
    attrs: {
      "auto": 3000,
      "watch-items": _vm.list
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('carousel-item', {
      key: item.url
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }), 1)], 1)])], 1), _vm._v(" "), _c('router-view', {
    staticClass: "uk-width uk-background-default"
  })], 1)]), _vm._v(" "), _c('dashboard-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('hr', {
    staticClass: "uk-wdith uk-divider-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-overflow-auto table-holder"
  }, [_c('table', {
    staticClass: "uk-table uk-table-middle uk-table-divider uk-margin-remove-top uk-table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "85px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('data')
      }
    }
  }, [_vm._v("Data\n                "), (_vm.orderKey == 'data') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Godzina\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('status')
      }
    }
  }, [_vm._v("Status\n                "), (_vm.orderKey == 'status') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('doctor')
      }
    }
  }, [_vm._v("Lekarz\n                "), (_vm.orderKey == 'doctor') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    on: {
      "click": function($event) {
        return _vm.sortBy('reason')
      }
    }
  }, [_vm._v("Powód wizyty\n                "), (_vm.orderKey == 'reason') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "uk-visible@m",
    staticStyle: {
      "width": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('position')
      }
    }
  }, [_vm._v("\n                  Numer w kolejce\n                  "), (_vm.orderKey == 'position') ? _c('i', {
    staticClass: "uk-icon-link",
    attrs: {
      "uk-icon": this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down',
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Dostępne działania\n\n              ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visits), function(visit) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDate")(visit.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(visit.data)))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [(visit.status === 'zarejestrowana') ? _c('span', {
      staticClass: "uk-label uk-label-primary"
    }, [_vm._v(_vm._s(visit.status))]) : _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v(_vm._s(visit.status))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [_vm._v(_vm._s(visit.doctor) + " " + _vm._s(visit.specjalizacja))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m"
    }, [_vm._v(_vm._s(visit.reason))]), _vm._v(" "), _c('td', {
      staticClass: "uk-visible@m",
      staticStyle: {
        "text-align": "center"
      }
    }, [(visit.position === '-1') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(visit.position))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-button-group"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'visit',
          params: {
            visitId: visit.idrejestracja,
            status: visit.status,
            ankieta: visit.ankieta,
            reason: visit.reason,
            doctor: visit.doctor,
            data: visit.data,
            position: visit.position,
            adres1: visit.adres1,
            adres2: visit.adres2,
            information: visit.info,
            type: visit.type,
            cena: visit.cena
          }
        }
      }
    }, [(visit.idrejestracja) ? _c('button', {
      staticClass: "see-more-btn uk-button uk-button-primary",
      attrs: {
        "type": "button",
        "title": "Otwórz pełen widok wizyty",
        "uk-tooltip": "pos: bottom"
      }
    }, [_vm._v("\n                    Zobacz\n                  ")]) : _vm._e()])], 1)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "uk-padding-remove"
  }, [_vm._v("Moje wizyty "), _c('div', {
    attrs: {
      "id": "visitLoader",
      "uk-spinner": ""
    }
  })])])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-container",
    staticStyle: {
      "height": "calc(100% - 55px)"
    }
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-left margin-top-responsive"
  }, [_c('div', {
    staticClass: "uk-padding-small",
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), (_vm.loginShow === false) ? _c('div', {
    staticClass: "uk-flex uk-flex-wrap uk-flex-center padding-responsive"
  }, [_c('div', {
    staticClass: "uk-width-1-2@s"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n          Ustawienie nowego hasła\n        ")]), _vm._v(" "), (_vm.error_box) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podany numer pacjenta lub hasło jest nieprawidłowe.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_mismatch) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_characters) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_empty) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić ID pacjenta oraz hasło.")])]) : _vm._e(), _vm._v(" "), (_vm.error_terms) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('p', [_vm._v("Akceptacja informacji o przetwarzaniu jest wymagana.")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew),
      expression: "credentials.passNew"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew_2),
      expression: "credentials.passNew_2"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Powtórz nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew_2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    attrs: {
      "id": "terms"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.terms),
      expression: "credentials.terms"
    }],
    staticClass: "uk-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.credentials.terms) ? _vm._i(_vm.credentials.terms, null) > -1 : (_vm.credentials.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.credentials.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.credentials, "terms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.credentials, "terms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.credentials, "terms", $$c)
        }
      }
    }
  }), _vm._v("\n              Zapoznałem się z "), _c('a', {
    attrs: {
      "uk-toggle": "target: #terms-modal",
      "href": "#"
    }
  }, [_vm._v("informacją o administratorze i przetwarzaniu danych")])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [(Object.getOwnPropertyNames(_vm.$route.params).length === 0) ? _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "id": "newpassbtn"
    },
    on: {
      "click": _vm.NewPass
    }
  }, [_vm._v("Potwierdź zmiane hasła")]) : _vm._e(), _vm._v(" "), (Object.getOwnPropertyNames(_vm.$route.params).length !== 0) ? _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "id": "hashnewpassbtn"
    },
    on: {
      "click": _vm.HashNewPass
    }
  }, [_vm._v("Zatwierdź")]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.loginShow === true) ? _c('div', {
    staticClass: "uk-card uk-card-default uk-card-body padding-responsive"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-wrap uk-flex-center"
  }, [_c('div', {
    staticClass: "uk-width-1 uk-width-1-2@m"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n            Logowanie do konta Pacjenta?\n          ")]), _vm._v(" "), (Object.getOwnPropertyNames(_vm.$route.params).length !== 0) ? _c('h4', [_vm._v("Id Pacjenta: " + _vm._s(_vm.$route.params.id))]) : _vm._e(), _vm._v(" "), (_vm.error_box) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podany numer pacjenta lub hasło jest nieprawidłowe.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_mismatch) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_characters) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_empty) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić ID pacjenta oraz hasło.")])]) : _vm._e(), _vm._v(" "), (_vm.error_terms) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('p', [_vm._v("Akceptacja informacji o przetwarzaniu jest wymagana.")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.ID),
      expression: "credentials.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "ID pacjenta",
      "id": "idinp"
    },
    domProps: {
      "value": (_vm.credentials.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "ID", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.pass),
      expression: "credentials.pass"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Hasło",
      "id": "passinp"
    },
    domProps: {
      "value": (_vm.credentials.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "pass", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-between"
  }, [(_vm.logging_in === false) ? _c('button', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "id": "loginbtn"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Zaloguj")]) : _vm._e(), _vm._v(" "), (_vm.logging_in !== false) ? _c('button', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "id": "loginbtn-disabled",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-spinner"
  }), _vm._v(" Trwa uwierzytelnianie\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-link uk-margin-left",
    attrs: {
      "type": "button",
      "uk-toggle": "target: #rememberButtons"
    }
  }, [_vm._v("Problem z logowaniem")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "terms-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Informacja dla pacjenta")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    domProps: {
      "innerHTML": _vm._s(_vm.config.clinic_info.terms)
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "remember-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Przypomnienie hasła")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.ID),
      expression: "remember.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "ID pacjenta",
      "id": "rememberidinp"
    },
    domProps: {
      "value": (_vm.remember.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remember, "ID", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.email),
      expression: "remember.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Email podany przy rejestracji",
      "id": "rememberemailinp"
    },
    domProps: {
      "value": (_vm.remember.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.rememberAction.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remember, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rememberAction
    }
  }, [_vm._v("Przypomnij")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "id-patient-reminder-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Przypomnienie ID pacjenta")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('999-999-999'),
      expression: "'999-999-999'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.phoneNumber),
      expression: "remember.phoneNumber"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "Numer telefonu podany przy rejestracji"
    },
    domProps: {
      "value": (_vm.remember.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remember, "phoneNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99999999999'),
      expression: "'99999999999'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.pesel),
      expression: "remember.pesel"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "Numer PESEL"
    },
    domProps: {
      "value": (_vm.remember.pesel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remember, "pesel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rememberActionID
    }
  }, [_vm._v("Przypomnij")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "email-patient-reminder-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Brak adresu email")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n        Adres email będzie używany w celu późniejszego przypomnienia hasła do konta. Brak podania adresu email będzie wiązał się z konicznością przypomnienia hasła w klinice.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.email),
      expression: "remember.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Twój aktualny email"
    },
    domProps: {
      "value": (_vm.remember.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remember, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEmail
    }
  }, [_vm._v("Zapisz")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firstlogin-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Pierwsze logowanie")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.ID),
      expression: "credentials.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "ID pacjenta"
    },
    domProps: {
      "value": (_vm.credentials.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "ID", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.firstLogin
    }
  }, [_vm._v("Wyślij SMS z hasłem tymczasowym")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-right uk-margin-top",
    attrs: {
      "id": "rememberButtons",
      "hidden": ""
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #id-patient-reminder-modal",
      "id": "rememberIDBtn"
    }
  }, [_vm._v("Przypomnij ID pacjenta")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #remember-modal",
      "id": "rememberbtn"
    }
  }, [_vm._v("Przypomnij hasło")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-hidden@m uk-margin-top"
  }, [_c('span', {
    staticClass: "uk-badge",
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "font-size": "medium"
    }
  }, [_vm._v("lub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1 uk-width-1-2@m"
  }, [_c('div', {
    staticClass: "uk-card uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n            Pierwsze logowanie?\n          ")]), _vm._v(" "), _c('p', [_vm._v("Jeżeli jesteś naszym Pacjentem i podczas pobytu w placówce otrzymałeś sms z identyfikatorem aktywuj konto.")]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #firstlogin-modal",
      "id": "firstLoginBtn"
    }
  }, [_vm._v("Aktywuj konto")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-visible@m uk-position-absolute",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_c('span', {
    staticClass: "uk-badge",
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "font-size": "medium"
    }
  }, [_vm._v("lub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Zamknij")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', [_vm._v("Jeżeli nie podałeś adresu email podczas logowania, przypomnienie hasła może się odbyć tylko w klinice.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_empty_email",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź poprawny adres email")])])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-light"
  }, [_c('nav', {
    staticClass: "uk-navbar-container",
    style: (_vm.config.navStyleObject),
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav uk-visible@m"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refreshMain.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: home"
    }
  }), _vm._v("\n              Moje wizyty\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'data',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: user"
    }
  }), _vm._v("\n              Moje dane\n            ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.menuRejestracjaLink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: bookmark"
    }
  }), _vm._v("\n              E-rejestracja\n            ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: phone"
    }
  }), _vm._v("\n              Kontakt z kliniką\n            ")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "uk-navbar-nav uk-hidden@m"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right uk-flex-right uk-text-middle uk-hidden@m"
  }, [_c('span', {
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie.",
      "uk-tooltip": "pos: bottom"
    }
  }, [_vm._v("Sesja wygaśnie za " + _vm._s(_vm.$parent.sessionValidToText))]), _vm._v(" "), _c('a', {
    staticClass: "uk-navbar-toggle",
    attrs: {
      "uk-navbar-toggle-icon": "",
      "uk-toggle": "target: #offcanvas-nav"
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "offcanvas-nav",
      "uk-offcanvas": "overlay: true"
    }
  }, [_c('div', {
    staticClass: "uk-offcanvas-bar uk-flex uk-flex-column"
  }, [_c('ul', {
    staticClass: "uk-nav uk-nav-primary "
  }, [_c('li', {
    staticClass: "uk-text-center"
  }, [_c('a', [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refreshMain.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: home"
    }
  }), _vm._v("\n                  Moje wizyty")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'data',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: question"
    }
  }), _vm._v("\n                  Moje dane")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: phone"
    }
  }), _vm._v("\n                  Kontakt z kliniką")])], 1), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-divider"
  }), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-navbar-item uk-visible@m"
  }, [_c('button', {
    staticClass: "uk-button uk-button-danger",
    attrs: {
      "id": "logout_btn"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: sign-out"
    }
  }), _vm._v("Wyloguj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "log-out",
    attrs: {
      "href": "#",
      "id": "logout_btn_small"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: sign-out"
    }
  }), _vm._v("\n                  Wyloguj")])])
}]}

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[160]);


// WEBPACK FOOTER //
// static/js/app.c29cba388e52f22f68db.js